// // // ✅ File: src/views/LeadSourceMapping/LeadSourceMappingList.jsx
// // import React, { useEffect, useState } from 'react';
// // import { Card, CardTitle, CardBody, Button, Table } from 'reactstrap';
// // import { useNavigate } from 'react-router-dom';
// // import { apiService } from '../../constants/ApiService';
// // import VendorBranchSelector from '../../components/VendorBranchSelector';
// // import { useSelector } from 'react-redux';
// // import conditionalDataLoad from '../../utils/conditionalDataLoad';
// // import useVendorBranch from '../../utils/useVendorBranch';
// // import { toast } from 'react-toastify';

// // const LeadSourceMappingList = () => {
// //   const { user } = useSelector((state) => state.authState);
// //   const navigate = useNavigate();

// //   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
// //     useVendorBranch(user);

// //   const [errorMessage, setErrorMessage] = useState({});
// //   const [list, setList] = useState([]);

// //   // ✅ Same like Weekend: start empty
// //   const [selectionData, setSelectionData] = useState({
// //     vendor_id: '',
// //     branch_id: '',
// //   });

// //   const onHandleAdd = () => {
// //     navigate('/save-source-map');
// //   };

// //   const onHandleEdit = (id) => {
// //     const selected = list.find((x) => x.id === id);
// //     navigate('/save-source-map', { state: { ...(selected || {}) } });
// //   };

// //   const GetList = async () => {
// //     try {
// //       const vendorId = selectionData.vendor_id || '';
// //       const branchId = selectionData.branch_id || '';

// //       const res = await apiService.get(
// //         `api/lead-source-mapping/List?vendorId=${vendorId}&branchId=${branchId}`
// //       );

// //       if (res?.success === true) {
// //         setList(res.data || []);
// //       } else {
// //         setList([]);
// //         toast.error(res?.message || 'Failed');
// //       }
// //     } catch (e) {
// //       console.error(e);
// //       toast.error('Something went wrong');
// //     }
// //   };

// //   const onHandleDelete = async (id) => {
// //     try {
// //       const res = await apiService.delete(
// //         `api/lead-source-mapping/Delete?id=${id}`
// //       );
// //       if (res?.success === true) {
// //         toast.success(res?.message || 'Deleted');
// //         GetList();
// //       } else {
// //         toast.error(res?.message || 'Failed');
// //       }
// //     } catch (e) {
// //       console.error(e);
// //       toast.error('Something went wrong');
// //     }
// //   };

// //   useEffect(() => {
// //     const canLoad = conditionalDataLoad({
// //       hasMultiBranch,
// //       hasSingleBranch,
// //       isSuperAdmin,
// //       isAdmin,
// //       vendorId: selectionData.vendor_id,
// //       branchId: selectionData.branch_id,
// //     });

// //     if (canLoad) {
// //       GetList();
// //     }
// //   }, [selectionData.vendor_id, selectionData.branch_id]);

// //   return (
// //     <>
// //       <div className='text-right mb-2'>
// //         <Button color='primary' onClick={onHandleAdd}>
// //           <i className='bi bi-plus-circle' /> Add Lead Source Mapping
// //         </Button>
// //       </div>

// //       {/* ✅ EXACT SAME AS WEEKEND */}
// //       <VendorBranchSelector
// //         user={user}
// //         selectionData={selectionData}
// //         setSelectionData={setSelectionData}
// //         errorMessage={errorMessage}
// //         accessButton={true}
// //       />

// //       <Card className='card-box pd-20 mb-20'>
// //         <CardTitle className='p-3 mb-0'>
// //           <i className='bi bi-diagram-3 mr-2' /> Lead Source Mapping List
// //         </CardTitle>

// //         <CardBody>
// //           <Table striped hover responsive>
// //             <thead>
// //               <tr>
// //                 <th>#</th>
// //                 <th>Edit</th>
// //                 <th>Platform</th>
// //                 <th>Source</th>
// //                 <th>Medium</th>
// //                 <th>Campaign</th>
// //                 <th>Form</th>
// //                 <th>Active</th>
// //                 <th>Delete</th>
// //               </tr>
// //             </thead>

// //             <tbody>
// //               {list.length > 0 ? (
// //                 list.map((x, i) => (
// //                   <tr key={x.id}>
// //                     <td>{i + 1}</td>

// //                     <td>
// //                       <i
// //                         className='bi bi-pencil text-primary'
// //                         style={{ cursor: 'pointer' }}
// //                         onClick={() => onHandleEdit(x.id)}
// //                         title='Edit'
// //                       />
// //                     </td>

// //                     <td>{x.platform}</td>
// //                     <td>{x.source}</td>
// //                     <td>{x.medium}</td>

// //                     <td>
// //                       {x.campaign_name}
// //                       <br />
// //                       <small className='text-muted'>{x.campaign_id}</small>
// //                     </td>

// //                     <td>
// //                       {x.form_name}
// //                       <br />
// //                       <small className='text-muted'>{x.form_id}</small>
// //                     </td>

// //                     <td>{x.is_active ? 'Yes' : 'No'}</td>

// //                     {/* ✅ Delete icon instead of button */}
// //                     <td>
// //                       <i
// //                         className='bi bi-trash text-danger'
// //                         style={{ cursor: 'pointer' }}
// //                         onClick={() => onHandleDelete(x.id)}
// //                         title='Delete'
// //                       />
// //                     </td>
// //                   </tr>
// //                 ))
// //               ) : (
// //                 <tr>
// //                   <td colSpan='11' className='text-center'>
// //                     No data available
// //                   </td>
// //                 </tr>
// //               )}
// //             </tbody>
// //           </Table>
// //         </CardBody>
// //       </Card>
// //     </>
// //   );
// // };

// // export default LeadSourceMappingList;
// //SignalR
// import React, { useEffect, useState, useRef, useCallback } from 'react';
// import { Card, CardTitle, CardBody, Button, Table } from 'reactstrap';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { useSelector } from 'react-redux';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';
// import useVendorBranch from '../../utils/useVendorBranch';
// import { toast } from 'react-toastify';
// import {
//   createAppConnection,
//   joinModuleGroup,
//   leaveModuleGroup,
//   subscribeRealtimeUpdate,
//   unsubscribeRealtimeUpdate,
// } from '../../utils/signalRService';

// const MODULE_NAME = 'LeadSourceMapping';

// const LeadSourceMappingList = () => {
//   const { user } = useSelector((state) => state.authState);
//   const navigate = useNavigate();

//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const [errorMessage, setErrorMessage] = useState({});
//   const [list, setList] = useState([]);

//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });

//   const currentGroupRef = useRef({
//     module: null,
//     vendorId: null,
//     branchId: null,
//   });

//   const onHandleAdd = () => {
//     navigate('/save-source-map');
//   };

//   const onHandleEdit = (id) => {
//     const selected = list.find((x) => x.id === id);
//     navigate('/save-source-map', { state: { ...(selected || {}) } });
//   };

//   const GetList = useCallback(async () => {
//     try {
//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';

//       const res = await apiService.get(
//         `api/lead-source-mapping/List?vendorId=${vendorId}&branchId=${branchId}`
//       );

//       if (res?.success === true) {
//         setList(res.data || []);
//       } else {
//         setList([]);
//         toast.error(res?.message || 'Failed');
//       }
//     } catch (e) {
//       console.error(e);
//       toast.error('Something went wrong');
//     }
//   }, [selectionData.vendor_id, selectionData.branch_id]);

//   const onHandleDelete = async (id) => {
//     const ok = window.confirm('Are you sure you want to delete this item?');
//     if (!ok) return;

//     try {
//       const res = await apiService.delete(
//         `api/lead-source-mapping/Delete?id=${id}`
//       );

//       if (res?.success === true) {
//         toast.success(res?.message || 'Deleted');
//         GetList();
//       } else {
//         toast.error(res?.message || 'Failed');
//       }
//     } catch (e) {
//       console.error(e);
//       toast.error('Something went wrong');
//     }
//   };

//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });

//     if (canLoad) {
//       GetList();
//     } else {
//       setList([]);
//     }
//   }, [
//     selectionData.vendor_id,
//     selectionData.branch_id,
//     hasMultiBranch,
//     hasSingleBranch,
//     isSuperAdmin,
//     isAdmin,
//     GetList,
//   ]);

//   useEffect(() => {
//     let mounted = true;

//     const setupSignalR = async () => {
//       try {
//         await createAppConnection();

//         const vendorId = selectionData.vendor_id || 0;
//         const branchId = selectionData.branch_id || 0;

//         const prev = currentGroupRef.current;

//         if (
//           prev.vendorId &&
//           prev.branchId &&
//           (String(prev.vendorId) !== String(vendorId) ||
//             String(prev.branchId) !== String(branchId))
//         ) {
//           await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
//         }

//         if (vendorId && branchId) {
//           await joinModuleGroup(MODULE_NAME, vendorId, branchId);

//           currentGroupRef.current = {
//             module: MODULE_NAME,
//             vendorId,
//             branchId,
//           };
//         }

//         unsubscribeRealtimeUpdate();

//         await subscribeRealtimeUpdate((payload) => {
//           if (!mounted) return;
//           if (!payload) return;

//           const isSameModule = String(payload.module || '') === MODULE_NAME;
//           const isSameVendor =
//             String(payload.vendorId || '') === String(vendorId || '');
//           const isSameBranch =
//             String(payload.branchId || '') === String(branchId || '');

//           if (isSameModule && isSameVendor && isSameBranch) {
//             console.log('LeadSourceMapping realtime update received:', payload);
//             GetList();
//           }
//         });
//       } catch (err) {
//         console.error('SignalR error:', err);
//       }
//     };

//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });

//     if (canLoad) {
//       setupSignalR();
//     }

//     return () => {
//       mounted = false;
//     };
//   }, [
//     selectionData.vendor_id,
//     selectionData.branch_id,
//     hasMultiBranch,
//     hasSingleBranch,
//     isSuperAdmin,
//     isAdmin,
//     GetList,
//   ]);

//   useEffect(() => {
//     return () => {
//       unsubscribeRealtimeUpdate();

//       const prev = currentGroupRef.current;
//       if (prev?.vendorId && prev?.branchId) {
//         leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(
//           console.error
//         );
//       }
//     };
//   }, []);

//   return (
//     <>
//       <div className='text-right mb-2'>
//         <Button color='primary' onClick={onHandleAdd}>
//           <i className='bi bi-plus-circle' /> Add Lead Source Mapping
//         </Button>
//       </div>

//       <VendorBranchSelector
//         user={user}
//         selectionData={selectionData}
//         setSelectionData={setSelectionData}
//         errorMessage={errorMessage}
//         accessButton={true}
//       />

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='p-3 mb-0'>
//           <i className='bi bi-diagram-3 mr-2' /> Lead Source Mapping List
//         </CardTitle>

//         <CardBody>
//           <Table striped hover responsive>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Edit</th>
//                 <th>Platform</th>
//                 <th>Source</th>
//                 <th>Medium</th>
//                 <th>Campaign</th>
//                 <th>Form</th>
//                 <th>Active</th>
//                 <th>Delete</th>
//               </tr>
//             </thead>

//             <tbody>
//               {list.length > 0 ? (
//                 list.map((x, i) => (
//                   <tr key={x.id}>
//                     <td>{i + 1}</td>

//                     <td>
//                       <i
//                         className='bi bi-pencil text-primary'
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => onHandleEdit(x.id)}
//                         title='Edit'
//                       />
//                     </td>

//                     <td>{x.platform}</td>
//                     <td>{x.source}</td>
//                     <td>{x.medium}</td>

//                     <td>
//                       {x.campaign_name}
//                       <br />
//                       <small className='text-muted'>{x.campaign_id}</small>
//                     </td>

//                     <td>
//                       {x.form_name}
//                       <br />
//                       <small className='text-muted'>{x.form_id}</small>
//                     </td>

//                     <td>{x.is_active ? 'Yes' : 'No'}</td>

//                     <td>
//                       <i
//                         className='bi bi-trash text-danger'
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => onHandleDelete(x.id)}
//                         title='Delete'
//                       />
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan='11' className='text-center'>
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default LeadSourceMappingList;
import React, { useEffect, useState, useCallback } from 'react';
import { Card, CardTitle, CardBody, Button, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';
import { toast } from 'react-toastify';

const getPayload = (res) => {
  if (
    res &&
    typeof res === 'object' &&
    ('success' in res ||
      'status' in res ||
      'isSuccess' in res ||
      'message' in res)
  ) {
    return res;
  }

  if (
    res?.data &&
    typeof res.data === 'object' &&
    ('success' in res.data ||
      'status' in res.data ||
      'isSuccess' in res.data ||
      'message' in res.data)
  ) {
    return res.data;
  }

  return res ?? {};
};

const LeadSourceMappingList = () => {
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [list, setList] = useState([]);

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const onHandleAdd = () => {
    navigate('/save-source-map');
  };

  const onHandleEdit = (id) => {
    const selected = list.find((x) => x.id === id);
    navigate('/save-source-map', { state: { ...(selected || {}) } });
  };

  const GetList = useCallback(async () => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const res = await apiService.get(
        `api/lead-source-mapping/List?vendorId=${vendorId}&branchId=${branchId}`,
      );

      const payload = getPayload(res);

      const rows =
        payload?.data || payload?.Data || payload?.list || payload?.List || [];

      if (
        payload?.success === true ||
        payload?.status === true ||
        payload?.isSuccess === true
      ) {
        setList(Array.isArray(rows) ? rows : []);
      } else {
        setList([]);
        toast.error(payload?.message || 'Failed');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong');
      setList([]);
    }
  }, [selectionData.vendor_id, selectionData.branch_id]);

  const onHandleDelete = async (id) => {
    const ok = window.confirm('Are you sure you want to delete this item?');
    if (!ok) return;

    try {
      const res = await apiService.delete(
        `api/lead-source-mapping/Delete?id=${id}`,
      );

      const payload = getPayload(res);

      if (
        payload?.success === true ||
        payload?.status === true ||
        payload?.isSuccess === true
      ) {
        toast.success(payload?.message || 'Deleted successfully');
        GetList();
      } else {
        toast.error(payload?.message || 'Delete failed');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      GetList();
    } else {
      setList([]);
    }
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    GetList,
  ]);

  return (
    <>
      <div className='text-right mb-2'>
        <Button color='primary' onClick={onHandleAdd}>
          <i className='bi bi-plus-circle' /> Add Lead Source Mapping
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='p-3 mb-0'>
          <i className='bi bi-diagram-3 mr-2' /> Lead Source Mapping List
        </CardTitle>

        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Edit</th>
                <th>Platform</th>
                <th>Source</th>
                <th>Medium</th>
                <th>Campaign</th>
                <th>Form</th>
                <th>Status</th>
                <th>Delete</th>
              </tr>
            </thead>

            <tbody>
              {list.length > 0 ? (
                list.map((x, i) => (
                  <tr key={x.id}>
                    <td>{i + 1}</td>

                    <td>
                      <i
                        className='bi bi-pencil text-primary'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleEdit(x.id)}
                        title='Edit'
                      />
                    </td>

                    <td>{x.platform || '-'}</td>
                    <td>{x.source || '-'}</td>
                    <td>{x.medium || '-'}</td>

                    <td>
                      {x.campaign_name || '-'}
                      <br />
                      <small className='text-muted'>
                        {x.campaign_id || ''}
                      </small>
                    </td>

                    <td>
                      {x.form_name || '-'}
                      <br />
                      <small className='text-muted'>{x.form_id || ''}</small>
                    </td>

                    <td>{x.is_active ? 'Active' : 'Inactive'}</td>

                    <td>
                      <i
                        className='bi bi-trash text-danger'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleDelete(x.id)}
                        title='Delete'
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='9' className='text-center'>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default LeadSourceMappingList;
